
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface LotteryUser {
    id: string;
    uid: string;
    name: string;
    phone_num: string;
    profile_pic: string;
    gender: string;
    gift_name: string;
    gift_pic: string;
    num: number;
    is_lottery_winner: boolean;
    activity_id: string;
    assigning: boolean;
    lottery_name: string;
    lottery_phone: string;
    lottery_address: string;
    lottery_notes: string;
    lottery_rank: string;
}

interface Gift {
    id: string;
    name: string;
    pic: string;
}

interface Activity {
    id: string;
    activity_name: string;
    gift_id: string;
    gift_name: string;
    gift_pic: string;
    bag_item_list_id?: string;
    file_name?: string;
}

@Component({
    selector: 'app-lottery',
    templateUrl: './lottery.component.html',
    styleUrls: ['./lottery.component.css']
})
export class LotteryComponent implements OnInit {

    loading = false;
    allUsers: LotteryUser[] = [];
    filteredUsers: LotteryUser[] = [];
    giftList: Gift[] = [];
    activityList: Activity[] = [];

    filterObj = {
        activityId: '',
        giftID: '',
        minCount: null as number | null,
        minAmount: null as number | null,
        gender: '',
        searchKeyword: ''
    };

    // 新增活動彈窗
    showAddActivityModal = false;
    newActivityName = '';
    newActivityGiftId = '';
    showActivityGiftDropdown = false;

    // 禮物下拉選單
    showGiftDropdown = false;
    giftLockedByActivity = false;

    // 活動下拉選單
    showActivityDropdown = false;

    // 分頁
    pageSize = 15;
    currentPage = 1;
    totalPages = 1;
    totalCount = 0;

    // 排序
    sortField: 'num' | 'is_lottery_winner' | '' = '';
    sortOrder: 'asc' | 'desc' = 'desc';

    // 確認彈窗
    showConfirm = false;
    confirmTitle = '';
    confirmMessage = '';
    confirmUser: LotteryUser | null = null;
    confirmType: 'assign' | 'cancel' = 'assign';
    selectedActivityId = '';
    showConfirmActivityDropdown = false;

    // 禮物不符警告彈窗
    showGiftMismatchWarning = false;
    mismatchFilterGift: Gift | null = null;
    mismatchActivityGift: { name: string; pic: string } | null = null;

    // 填寫中獎資訊彈窗
    showWinnerInfoModal = false;
    winnerInfoUser: LotteryUser | null = null;
    winnerInfoForm = {
        name: '',
        phone: '',
        address: '',
        notes: '',
        rank: null as number | null
    };

    constructor(public httpClient: HttpClient) {}

    ngOnInit(): void {
        this.loadMockData();
        this.loadGifts();
        this.loadActivities();
        // TODO: 正式環境改回呼叫 API
        // this.loadUsers();
    }

    loadMockData(): void {
        this.allUsers = [
            
        ];

        this.filteredUsers = [...this.allUsers];
    }

    get pagedUsers(): LotteryUser[] {
        const start = (this.currentPage - 1) * this.pageSize;
        return this.filteredUsers.slice(start, start + this.pageSize);
    }

    loadGifts(): void {
        this.httpClient.post<any>('/customer_service/get_gift_list_temp.php', { type: 1 }).subscribe(
            (res) => {
                if (res && res.data) {
                    this.giftList = res.data.bag || [];
                }
            },
            () => {}
        );
    }

    loadActivities(): void {
        console.log('loadActivities'); 
        this.httpClient.post<any>('/customer_service/get_lottery_activity.php', {}).subscribe(
            (res) => {
                if (res && res.data) {
                    this.activityList = res.data;
                }
            },
            () => {}
        );
    }

    loadUsers(): void {
        this.loading = true;
        const params: any = {
            page: this.currentPage,
            count: this.pageSize
        };
        if (this.filterObj.activityId) params.activityId = this.filterObj.activityId;
        if (this.filterObj.giftID) params.giftID = this.filterObj.giftID;
        if (this.filterObj.minCount) params.minCount = this.filterObj.minCount;
        if (this.filterObj.minAmount) params.minAmount = this.filterObj.minAmount;
        // if (this.filterObj.gender) params.gender = this.filterObj.gender;
        if (this.filterObj.searchKeyword) params.searchKeyword = this.filterObj.searchKeyword;
        if (this.sortField) {
            params.sortField = this.sortField;
            params.sortOrder = this.sortOrder;
        }

        this.httpClient.post<any>(`/customer_service/search_lottery_user.php`, params).subscribe(
            (res) => {
                this.loading = false;
                if (res && res.data) {
                    this.filteredUsers = res.data.map((u: any) => ({
                        ...u,
                        is_lottery_winner: u.is_lottery_winner === '1' || u.is_lottery_winner === 1,
                        assigning: false
                    }));
                    this.totalCount = res.totalCount || 0;
                    this.totalPages = Math.max(1, Math.ceil(this.totalCount / this.pageSize));
                }
            },
            () => {
                this.loading = false;
            }
        );
    }

    onFilterChange(): void {
        this.applyLocalFilter();
    }

    onActivityChange(): void {
        // 如果禮物類型與最低數量都沒有數值，不執行搜索
        if (!this.filterObj.giftID && !this.filterObj.minCount) {
            return;
        }
        this.currentPage = 1;
        this.loadUsers();
    }

    toggleGiftDropdown(): void {
        if (this.giftLockedByActivity) return;
        this.showGiftDropdown = !this.showGiftDropdown;
    }

    selectGift(gift: Gift | null): void {
        this.filterObj.giftID = gift ? gift.id : '';
        this.showGiftDropdown = false;
        this.onFilterChange();
    }

    getSelectedGift(): Gift | null {
        return this.giftList.find(g => g.id === this.filterObj.giftID) || null;
    }

    // 活動下拉選單
    toggleActivityDropdown(): void {
        this.showActivityDropdown = !this.showActivityDropdown;
    }

    selectActivity(activity: Activity | null): void {
        this.filterObj.activityId = activity ? activity.id : '';
        this.showActivityDropdown = false;

        // 若活動有 bag_item_list_id，嘗試比對禮物清單
        if (activity && activity.bag_item_list_id) {
            const matched = this.giftList.find(g => g.id === activity.bag_item_list_id);
            if (matched) {
                this.filterObj.giftID = matched.id;
                this.giftLockedByActivity = true;
            } else {
                this.giftLockedByActivity = false;
            }
        } else {
            this.giftLockedByActivity = false;
        }

        this.onActivityChange();
    }

    getSelectedActivity(): Activity | null {
        return this.activityList.find(a => a.id === this.filterObj.activityId) || null;
    }

    applyFilter(): void {
        this.currentPage = 1;
        this.loadUsers();
    }

    applyLocalFilter(): void {
        let result = [...this.allUsers];

        if (this.filterObj.gender) {
            result = result.filter(u => u.gender === this.filterObj.gender);
        }
        if (this.filterObj.searchKeyword) {
            const kw = this.filterObj.searchKeyword.toLowerCase();
            result = result.filter(u =>
                u.uid.toLowerCase().includes(kw) ||
                u.name.toLowerCase().includes(kw)
            );
        }

        this.filteredUsers = result;
        this.totalPages = Math.max(1, Math.ceil(this.filteredUsers.length / this.pageSize));
        if (this.currentPage > this.totalPages) {
            this.currentPage = 1;
        }
    }

    resetFilter(): void {
        this.filterObj = {
            activityId: '',
            giftID: '',
            minCount: null,
            minAmount: null,
            gender: '',
            searchKeyword: ''
        };
        this.currentPage = 1;
        this.loadUsers();
    }

    getWinnerCount(): number {
        return this.filteredUsers.filter(u => u.is_lottery_winner).length;
    }

    trackByUserId(index: number, user: LotteryUser): string {
        return user.uid;
    }

    // 取得排行榜連結
    getRanklistUrl(): string {
        if (!this.filterObj.activityId) return '';
        const activity = this.activityList.find(a => a.id === this.filterObj.activityId);
        if (!activity) return '';
        const activityName = encodeURIComponent(activity.activity_name);
        const fileName = activity.file_name || 'lottery_ranklist.php';
        return `${environment.domain}/html/web/${fileName}?activity_name=${activityName}&id=${activity.id}&user_uid=7J1M7012ZHMH`;
    }

    // 開啟排行榜
    openRanklist(): void {
        const url = this.getRanklistUrl();
        if (url) {
            window.open(url, '_blank');
        }
    }

    // 分頁
    goToPage(page: number): void {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        this.loadUsers();
    }

    // 排序
    toggleSort(field: 'num' | 'is_lottery_winner'): void {
        if (this.sortField === field) {
            // 同一欄位，切換排序方向
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            // 不同欄位，預設降序
            this.sortField = field;
            this.sortOrder = 'desc';
        }
        this.currentPage = 1;
        this.loadUsers();
    }

    // 指定中獎
    assignWinner(user: LotteryUser): void {
        this.confirmType = 'assign';
        this.confirmTitle = '確認指定中獎';
        this.confirmMessage = `請選擇中獎活動，並確認指定此用戶為中獎者`;
        this.confirmUser = user;
        this.selectedActivityId = '';
        this.showConfirmActivityDropdown = false;
        this.showConfirm = true;
    }

    toggleConfirmActivityDropdown(): void {
        this.showConfirmActivityDropdown = !this.showConfirmActivityDropdown;
    }

    selectConfirmActivity(activity: Activity): void {
        this.selectedActivityId = activity.id;
        this.showConfirmActivityDropdown = false;
    }

    getSelectedConfirmActivity(): Activity | null {
        return this.activityList.find(a => a.id === this.selectedActivityId) || null;
    }

    // 取消中獎
    cancelWinner(user: LotteryUser): void {
        this.confirmType = 'cancel';
        this.confirmTitle = '確認取消中獎';
        this.confirmMessage = `確定要取消此用戶的中獎資格嗎？`;
        this.confirmUser = user;
        this.selectedActivityId = this.filterObj.activityId;
        this.showConfirm = true;
    }

    confirmAction(): void {
        if (!this.confirmUser) return;
        if (this.confirmType === 'assign' && !this.selectedActivityId) {
            return; // 必須選擇活動
        }

        // 檢查禮物是否相符
        if (this.confirmType === 'assign' && this.filterObj.giftID) {
            const selectedActivity = this.activityList.find(a => a.id === this.selectedActivityId);
            if (selectedActivity && selectedActivity.gift_id !== this.filterObj.giftID) {
                // 禮物不符，顯示警告彈窗
                this.mismatchFilterGift = this.getSelectedGift();
                this.mismatchActivityGift = {
                    name: selectedActivity.gift_name,
                    pic: selectedActivity.gift_pic
                };
                this.showGiftMismatchWarning = true;
                return;
            }
        }

        this.executeAssignWinner();
    }

    // 執行指定中獎 API
    executeAssignWinner(): void {
        if (!this.confirmUser) return;
        const user = this.confirmUser;
        this.showConfirm = false;
        this.showGiftMismatchWarning = false;

        const payload = {
            action: this.confirmType === 'assign' ? 0 : 2,
            user_id: user.id,
            activity_id: this.selectedActivityId
        };

        this.httpClient.post<any>("/customer_service/setting_lottery_winner.php", payload).subscribe(
            (res) => {
                user.assigning = false;
                if (res && res.status) {
                    user.is_lottery_winner = this.confirmType === 'assign';
                    this.loadUsers(); // 重新載入列表
                }
            },
            () => { user.assigning = false; }
        );

        this.confirmUser = null;
    }

    // 關閉禮物不符警告
    closeGiftMismatchWarning(): void {
        this.showGiftMismatchWarning = false;
    }

    // 確認繼續指定中獎（忽略禮物不符）
    confirmMismatchContinue(): void {
        this.executeAssignWinner();
    }

    closeConfirm(): void {
        this.showConfirm = false;
        this.confirmUser = null;
    }

    // 填寫中獎資訊
    editWinnerInfo(user: LotteryUser): void {
        this.winnerInfoUser = user;
        this.winnerInfoForm = {
            name: user.lottery_name || '',
            phone: user.lottery_phone || '',
            address: user.lottery_address || '',
            notes: user.lottery_notes || '',
            rank: user.lottery_rank ? Number(user.lottery_rank) : null
        };
        this.showWinnerInfoModal = true;
    }

    closeWinnerInfoModal(): void {
        this.showWinnerInfoModal = false;
        this.winnerInfoUser = null;
    }

    saveWinnerInfo(): void {
        if (!this.winnerInfoUser) return;

        console.log('winnerInfoActivityId:', this.winnerInfoUser);

        const payload = {
            action: 1,
            user_id: this.winnerInfoUser.id,
            activity_id: this.winnerInfoUser.activity_id,
            ...this.winnerInfoForm
        };

        this.httpClient.post<any>('/customer_service/setting_lottery_winner.php', payload).subscribe(
            (res) => {
                if (res && res.status) {
                    this.closeWinnerInfoModal();
                }
            },
            () => {}
        );

        // Mock: 直接關閉
        this.closeWinnerInfoModal();
    }

    // 新增活動
    openAddActivityModal(): void {
        this.newActivityName = '';
        this.newActivityGiftId = '';
        this.showActivityGiftDropdown = false;
        this.showAddActivityModal = true;
    }

    closeAddActivityModal(): void {
        this.showAddActivityModal = false;
        this.newActivityName = '';
        this.newActivityGiftId = '';
        this.showActivityGiftDropdown = false;
    }

    toggleActivityGiftDropdown(): void {
        this.showActivityGiftDropdown = !this.showActivityGiftDropdown;
    }

    selectActivityGift(gift: Gift): void {
        this.newActivityGiftId = gift.id;
        this.showActivityGiftDropdown = false;
    }

    getSelectedActivityGift(): Gift | null {
        return this.giftList.find(g => g.id === this.newActivityGiftId) || null;
    }

    saveActivity(): void {
        if (!this.newActivityName.trim() || !this.newActivityGiftId) return;

        this.httpClient.post<any>('/customer_service/setting_lottery_activity.php', {
            activity_name: this.newActivityName,
            gift_id: this.newActivityGiftId
        }).subscribe(
            (res) => {
                if (res && res.status) {
                    this.closeAddActivityModal();
                    this.loadActivities();
                }
            },
            () => {}
        );
    }
}
